import { AuthServiceImpl } from "./auth/auth.service.impl";
import { ChatServiceImpl } from "./chat/chat.service.impl";
import { EncrypterServiceImpl } from "./encrypter/encrypter.service.impl";
import { SignerServiceImpl } from "./signer/signer.service.impl";
import { GnoSafeSenderServiceImpl } from "./gno-safe-sender/gno-safe-sender.service.impl";
import { AccessControlServiceImpl } from "./access-control/access-control.service.impl";
export class Services {
    constructor(chatServiceApiKey) {
        this.authService = new AuthServiceImpl();
        this.accessControlService = new AccessControlServiceImpl();
        const encrypterService = new EncrypterServiceImpl(this.accessControlService);
        const signerService = new SignerServiceImpl();
        this.chatService = new ChatServiceImpl(chatServiceApiKey, encrypterService, signerService);
        this.safeSenderService = new GnoSafeSenderServiceImpl(this.chatService, signerService);
    }
}
